var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefits3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "83px",
    height: "66px",
    viewBox: "0 0 83 66",
    style: {
      enableBackground: "new 0 0 83 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_); fill: #fff;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 82.9,
    height: 66
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,22.1h12.2c0.1-0.5,0.3-1,0.5-1.5l1.3-2.5h-14c-1.1,0-2,0.9-2,2C18.4,21.2,19.2,22.1,20.4,22.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.6,54.4h-8.2V43.8h-4v10.7H22.5c-1.1,0-2,0.9-2,2v2.4c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1v-44 c0-1-0.3-2.1-0.7-3.1h24l2-4H7.1C3.2,7.9,0,11,0,14.9V18c0,1.1,0.9,2,2,2h8.2v38.9c0,3.9,3.1,7.1,7.1,7.1h42.1 c3.9,0,7.1-3.1,7.1-7.1v-2.4C66.6,55.3,65.6,54.4,64.6,54.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.5,27H20.4c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h16.2C35.2,29.9,34.2,28.5,33.5,27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,35.8H20.4c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h20.3c-0.1-0.3-0.2-0.8-0.2-1.1v-1.8 C40.5,36.5,40.5,36.1,40.5,35.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,46.7c0,1.1,0.9,2,2,2h25.8c1.1,0,2-0.9,2-2s-0.9-2-2-2H20.4C19.2,44.7,18.4,45.6,18.4,46.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.8,22.3L75.9,8.6c-0.3-0.5-0.7-0.8-1.2-0.9l-9.4,0.1c-0.4-1.3-1.4-2.4-2.6-3.1V2.9c0-1.6-1.3-2.9-2.9-2.9 c-1.6,0-2.9,1.3-2.9,2.9v1.8c-1.2,0.7-2.2,1.8-2.6,3.1l-9.4-0.1c-0.5,0-1,0.3-1.2,0.9l-6.9,13.7c-0.2,0.4-0.3,0.9-0.2,1.3 c1.2,4.3,4.5,6.3,8.4,6.3s7.2-2,8.4-6.3c0.1-0.4,0.1-0.9-0.2-1.3l-5.4-10.7h6.5c0.4,1.3,1.4,2.4,2.6,3.1v13.6c0,3.4-2.6,6.3-6,6.7 l-5.3,0.6c-0.6,0.1-1,0.5-1,1.1v1.8c0,0.6,0.5,1.1,1.1,1.1h28.3c0.6,0,1.1-0.5,1.1-1.1v-1.8c0-0.6-0.4-1-1-1.1l-5.3-0.6 c-3.4-0.3-6-3.2-6-6.7V14.8c1.2-0.7,2.1-1.7,2.6-3.1h6.5l-5.4,10.7c-0.2,0.4-0.3,0.9-0.2,1.3c1.2,4.3,4.5,6.3,8.4,6.3 c3.9,0,7.2-2,8.4-6.3C83.1,23.3,83,22.8,82.8,22.3 M49.4,21.8h-9l4.5-8.9L49.4,21.8z M70.1,21.8l4.5-8.9l4.5,8.9H70.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits3);
export default __webpack_public_path__ + "static/media/Benefits3.60fac9f690a3265e0ddd3cfed8fe6169.svg";
export { ForwardRef as ReactComponent };